import React from 'react';

import PropTypes from 'prop-types';

import { SpinnerExternalWrapper, SpinnerLoader, SpinnerWrapper } from './style';

const Spinner = ({ reverse, isOnChangePassword }) => (
  <SpinnerExternalWrapper>
    <SpinnerWrapper isOnChangePassword>
      <SpinnerLoader reverse={reverse} />
    </SpinnerWrapper>
  </SpinnerExternalWrapper>
);

Spinner.propTypes = {
  reverse: PropTypes.bool,
  isOnChangePassword: PropTypes.bool
};

Spinner.defaultProps = {
  isOnChangePassword: false
};

export default Spinner;
